import axios from 'axios'

export const login = ({dispatch}, payload) => {

    axios.post('/serviceProviderPortal/index.php', payload)
    .then(res => {
        if(res.data.status) {
            dispatch('storeAuthResponse', {data: res.data, goHome: true})
        } else {
            alert('Error de inicio de sesion')
        }

    })
    .catch(error => {
        console.log(error)
    })
    
}

export const storeAuthResponse = ({commit, dispatch}, payload) => {

    commit('setUserauthResponse', payload.data)

    if(payload.goHome) {
        window.location = '/'
    }
}
export const tryAutoLogin = ({commit, dispatch}) => {

    const accessToken = localStorage.getItem('accessToken')
    
    if(!accessToken) {
        return 
    }
    
    const postData = {access_token: accessToken}
    
    axios.post('/serviceProviderPortal/autoLogin.php', postData)
    .then(res => {
        
        if(res.data.status) {        
            dispatch('fetchPendingServiceEventList')
            dispatch('storeAuthResponse', {data: res.data, goHome: false})
        } else {
            dispatch('logout')
        }

    })
    .catch(error => {
       
    })
    
}

export const logout = ({commit}) => {
    commit('clearAuthData')        
    
}


// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js